export interface DynamicSettings {
	PageAlias: string;
	Secret: string;
	TTFrom: string;
	TTTo: string;
	IsQueueItOn: boolean;
	IsBancoEstadoOn: boolean;
	IsPeruCompraOn: boolean;
	IsAmericanOn: boolean;
	IsCarRentalOn: boolean;
	isHotelsOn: boolean;
	IsTransfersOn: boolean;
	QueueItPrefix: string;
	DefaultPromotionCodeCl: string;
	DefaultPromotionCodeAr: string;
	DefaultPromotionCodePe: string;
	DefaultPromotionCodeUs: string;
	DefaultPromotionCodeBr: string;
	DefaultPromotionCodeCo: string;
	DefaultPromotionCodePy: string;
	DefaultPromotionCodeUy: string;
	DefaultPromotionCodeEc: string;
	DefaultPromotionCodeDo: string;
	DefaultPromotionCodeGb: string;
	ShowFarePricesCultures: ShowFarePrices;
	DynamicCultureNameSettings: DynamicCultureNameSetting[];
	DynamicPromoCodeSettings: DynamicPromoCodeSetting[];
	DynamicInsuranceTabSettings: DynamicInsuranceTabSetting[];
	DefaultRouteCountrySettings: DefaultRouteCountrySetting[];
	DefaultSuperPromoCodeSettings: DefaultSuperPromoCodeSetting[];
	TimetableMaxMonthsFallback: number;
	RetargetingUrls: string[];
}

export interface ShowFarePrices {
	Cl: boolean;
	Ar: boolean;
	Pe: boolean;
	Us: boolean;
	Br: boolean;
	Co: boolean;
	Py: boolean;
	Uy: boolean;
	Ec: boolean;
	Do: boolean;
	Gb: boolean;
}

export interface DefaultRouteCountrySetting {
	Culture: string;
	DefaultOriginCountryCode: string;
	DefaultDestinationCountryCode: string;
}

export interface DefaultSuperPromoCodeSetting {
	Code: string;
	Culture: string;
}

export interface DynamicCultureNameSetting {
	Culture: string;
	Es: string;
	En: string;
	Pt: string;
}

export interface DynamicPromoCodeSetting {
	Code: string;
	Culture: string;
	RoleCode: string;
	ProgramCodeAndLevel: string;
}

export interface DynamicInsuranceTabSetting {
	Culture: string;
	IsActive: boolean;
	Url: string;
}

export type ActionType =
	| "invalidate_homewidgets"
	| "invalidate_navitairesettings"
	| "invalidate_page"
	| "invalidate_sitemap"
	| "invalidate_stations"
	| "invalidate_timetable"
	| "login"
	| "logoff"
	| "preview_off"
	| "preview_on"
	| "save_dynamic_settings"
	| "take_home_snapshot";

export interface AdminPostModel extends DynamicSettings {
	ActionType: ActionType;
	PageAlias: string; // page alias to invalidate
	Secret: string; // password for login
	TTFrom: string; // timetable from
	TTTo: string; // timetable to
}

export const DEFAULT_ADMIN_POST_MODEL: AdminPostModel = {
	ActionType: undefined,
	PageAlias: "",
	Secret: "",
	TTFrom: "",
	TTTo: "",
	IsQueueItOn: false,
	IsBancoEstadoOn: false,
	IsPeruCompraOn: false,
	IsAmericanOn: false,
	IsCarRentalOn: false,
	isHotelsOn: false,
	IsTransfersOn: false,
	QueueItPrefix: "",
	DefaultPromotionCodeCl: "",
	DefaultPromotionCodeAr: "",
	DefaultPromotionCodePe: "",
	DefaultPromotionCodeUs: "",
	DefaultPromotionCodeBr: "",
	DefaultPromotionCodeCo: "",
	DefaultPromotionCodePy: "",
	DefaultPromotionCodeUy: "",
	DefaultPromotionCodeEc: "",
	DefaultPromotionCodeDo: "",
	DefaultPromotionCodeGb: "",
	ShowFarePricesCultures: undefined,
	DynamicCultureNameSettings: [],
	DynamicPromoCodeSettings: [],
	DynamicInsuranceTabSettings: [],
	DefaultRouteCountrySettings: [],
	DefaultSuperPromoCodeSettings: [],
	TimetableMaxMonthsFallback: 0,
	RetargetingUrls: [],
};
